import { render, staticRenderFns } from "./AddCustom.vue?vue&type=template&id=9144e326&scoped=true&"
import script from "./AddCustom.vue?vue&type=script&lang=js&"
export * from "./AddCustom.vue?vue&type=script&lang=js&"
import style0 from "./AddCustom.vue?vue&type=style&index=0&id=9144e326&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9144e326",
  null
  
)

export default component.exports